import { Shared_Languages } from "src/backend/openapi/v1";
import { useCallback } from "react";
import { useLanguagesT } from "src/translation-hooks/languages";

export const useLanguagesTranslation = () => {
  const t = useLanguagesT();

  const getLanguagesTranslation = useCallback(
    (value: string | Shared_Languages) => {
      const enumValue: Shared_Languages = typeof value === "string" ? parseInt(value) : value;
      switch (enumValue) {
        case Shared_Languages.German:
          return t.german;
        case Shared_Languages.Danish:
          return t.danish;
        case Shared_Languages.English:
          return t.english;

        default:
          return "";
      }
    },
    [t]
  );

  return { getLanguagesTranslation };
};
